import React, { Component } from 'react';

import { 
  SpellList
} from "@dndModels";

import API from "@dndUtilities/system_api";

import SelectBox from "@components/input/selects/SelectBox";
import LoadingBox from "@components/input/LoadingBox";

type Props = {
  name: string;
  value: string;
  spell_lists: SpellList[] | null;
  allow_any: boolean;
  allow_class: boolean;
  allow_all: boolean;
  onChange: (id: string) => void;
  disabled: boolean;
}

export interface State {
  spell_lists: SpellList[];
  loading: boolean;
}

const api = API.getInstance();

class SelectSpellListBox extends Component<Props, State> {
  public static defaultProps = {
    spell_lists: null,
    allow_any: false,
    allow_class: false,
    allow_all: false,
    disabled: false
  };
  constructor(props: Props) {
    super(props);
    this.state = {
      spell_lists: [],
      loading: true
    };
  }

  componentDidMount() {
    this.load();
  }

  load() {
    this.setState({ loading: true }, () => {
      api.getObjects({data_type: "spell_list"}).then(res => {
        this.setState({ spell_lists: res as SpellList[], loading: false });
      });
    });
  }

  render() {
    if (this.state.loading) {
      return (<LoadingBox />);
    } else {
      const extra_options: string[] = [];
      if (this.props.allow_all) {
        extra_options.push("ALL");
      }
      if (this.props.allow_any) {
        extra_options.push("Any");
      }
      if (this.props.allow_class) {
        extra_options.push("Class");
      }
      return (
        <SelectBox 
          options={this.state.spell_lists}
          extra_options={extra_options}
          value={this.props.value} 
          name={this.props.name}
          disabled={this.props.disabled}
          onChange={(id: string) => {
            const objFinder = this.state.spell_lists ? this.state.spell_lists.filter(o => o._id === id) : [];
            if (objFinder.length === 1) {
              this.props.onChange(objFinder[0]._id);
            }
          }}
        />
      );
    }
  }
}

export default SelectSpellListBox;
